import { createContext } from "react";
const TPCouponProvider = createContext();
export default TPCouponProvider;

